<script setup>
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';

let emit = defineEmits(['update:modelValue']);
const props = defineProps(['modelValue', 'options', 'name']);
const input = useVModel(props, 'modelValue', emit);

const options = ref(props.options);
</script>

<template>
    <fieldset>
        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
            <!--
              Checked: "border-transparent", Not Checked: "border-gray-300"
              Active: "border-indigo-600 ring-2 ring-indigo-600"
            -->
            <label
                :class="{ 'border-indigo-600 ring-2 ring-indigo-600': option.value === input }"
                class="relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none"
                v-for="(option, index) in options"
                :key="option.value"
            >
                <input
                    type="radio"
                    :name="name"
                    :value="option.value"
                    v-model="input"
                    class="sr-only"
                    :aria-labelledby="`${name}-type-${index}-label`"
                    :aria-describedby="`${name}-type-${index}-description`"
                />
                <span class="flex flex-1">
                    <span class="flex flex-col">
                        <span :id="`${name}-type-${index}-label`" class="block text-sm font-medium text-gray-900">
                            {{ option.label }}
                        </span>
                        <span
                            :id="`${name}-type-${index}-description`"
                            class="mt-1 flex items-center text-sm text-gray-500"
                        >
                            {{ option.description }}
                        </span>
                    </span>
                </span>
                <!-- Not Checked: "invisible" -->
                <svg
                    class="h-5 w-5 text-indigo-600"
                    :class="{ invisible: option.value !== input }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                        clip-rule="evenodd"
                    />
                </svg>
                <!--
                  Active: "border", Not Active: "border-2"
                  Checked: "border-indigo-600", Not Checked: "border-transparent"
                -->
                <span
                    class="pointer-events-none absolute -inset-px rounded-lg border-2"
                    :class="{ 'border-indigo-600': option.value === input }"
                    aria-hidden="true"
                ></span>
            </label>
        </div>
    </fieldset>
</template>
